import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={toTop}
      data-testid="scroll-to-top"
      aria-label="Terug naar boven"
      title="Terug naar boven"
      className={`fixed z-40 bottom-5 right-5 w-11 h-11 rounded-full bg-[#1B6B2E] text-white shadow-md flex items-center justify-center transition duration-300 hover:bg-[#144F22] hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-[#1B6B2E]/40 ${
        visible ? "opacity-50 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp size={20} />
    </button>
  );
};
